import React from 'react';
import RowMenuBar from './rowMenuBar.jsx';
import ItemCellNumber from './number.jsx';
import ItemSelectionState from './selectionState.jsx';
import ItemLock from './lock.jsx';
import Segment from './segment.jsx';
import Description from './description.jsx';
import Duration from '../duration.jsx';
import StartTime from '../startTime.jsx';
import PresetDuration from '../presetDuration.jsx';
import {
  ColumnWidthStrings,
  EditableCellTypes,
  PlaceholderItemSegment,
  PlaceholderTitleRowItemSegment,
  PlaceholderItemDescription,
} from 'flux/stores/cuesheet/CuesheetConstants';
import classNames from 'classnames';
import HighlightCellMixin from 'main/components/show/cuesheet/highlightCellMixin';
import { Col, Row } from 'bootstrap';
import ItemTrackButton from './trackButton';
import TrackingUserPill from 'main/components/show/cuesheet/itemCell/trackingUserPill';

/**
 * Item Cell component
 *
 */
export default React.createClass({
  displayName: 'ItemCell',

  mixins: [HighlightCellMixin],

  propTypes: {
    eventId: React.PropTypes.string,
    teamId: React.PropTypes.string,
    user: React.PropTypes.object,
    item: React.PropTypes.any.isRequired,
    rowIndex: React.PropTypes.number.isRequired,
    rowId: React.PropTypes.string.isRequired,
    isCopied: React.PropTypes.bool,
    isTitleCopied: React.PropTypes.bool,
    isDescriptionCopied: React.PropTypes.bool,
    checkSelectionStatus: React.PropTypes.func, //EditableCellType
    editing: React.PropTypes.string, //EditableCellType
    corrupted: React.PropTypes.bool, //EditableCellType
    rowType: React.PropTypes.string, //RowType
  },

  contextTypes: {
    router: React.PropTypes.object.isRequired,
    user: React.PropTypes.object.isRequired,
  },

  render() {
    const {
      checkSelectionStatus,
      rowSelected,
      editing,
      isCopied,
      item,
      isTitleCopied,
    } = this.props;

    const { user, rowIndex } = this.props;

    const wrapperClasses = 'cs-item-cell-wrapper';

    const cellClasses = classNames(
      'cs-item-cell',
      'cs-cell',
      { 'cs-cell-copied': isCopied },
      this.getPersonalHighlightClass(),
    );

    const segmentPlaceholder = item.get('titleView')
      ? PlaceholderTitleRowItemSegment
      : PlaceholderItemSegment;

    const { teamId, eventId } = this.context.router.state.params;

    return (
      <div className={wrapperClasses}>
        <div
          className={cellClasses}
          style={Object.assign(
            {},
            this.getGlobalHighlightStyle(),
            this.getPersonalHighlightStyle(),
          )}
        >
          <ItemLock {...this.props} isLocked={item.get('locked')} />
          <ItemCellNumber
            {...this.props}
            isSelected={checkSelectionStatus(EditableCellTypes.ItemNumber)}
            isEditing={editing === EditableCellTypes.ItemNumber}
          />
          <ItemSelectionState
            user={user}
            rowIndex={rowIndex}
            isSelected={rowSelected}
          />
          <RowMenuBar {...this.props} />
          <div className="cs-item-cell-content">
            <TrackingUserPill {...this.props} />
            <ItemTrackButton
              {...{ teamId, eventId }}
              rowIndex={this.props.rowIndex}
            />
            <Segment
              {...this.props}
              isCopied={isTitleCopied}
              isSelected={checkSelectionStatus(EditableCellTypes.ItemTitle)}
              isEditing={editing === EditableCellTypes.ItemTitle}
              placeholder={segmentPlaceholder}
              partialCell
              titleFormat={item.get('titleFormat')}
              titleView={item.get('titleView')}
              title={item.get('title')}
            />
            {this._getDescriptionNode()}
          </div>
          {this._getClocksNode()}
        </div>
      </div>
    );
  },

  _getClocksNode() {
    const {
      width,
      displayStartTime,
      displayDuration,
      displayPresetDuration,
      durationDisplayType,
      item,
      checkSelectionStatus,
      isTracked,
      presetDurationDisplayType,
    } = this.props;

    const startTimeSelected = checkSelectionStatus(
      EditableCellTypes.ItemStartTime,
    );
    const presetSelected = checkSelectionStatus(
      EditableCellTypes.ItemPresetDuration,
    );
    const durationSelected = checkSelectionStatus(
      EditableCellTypes.ItemDuration,
    );

    const globalHighlightStyle = isTracked
      ? {}
      : this.getGlobalHighlightStyle();

    const style = Object.assign({}, globalHighlightStyle, {
      backgroundColor: 'transparent',
      paddingRight: '12px',
    });

    const startClock = displayStartTime ? (
      <div
        style={style}
        className={classNames({ 'cs-cell-selected': startTimeSelected })}
      >
        <StartTime
          {...this.props}
          isSelected={startTimeSelected}
          startOn={item.get('startOn')}
          startTimeBackwardAdjusted={item.get('startTimeBackwardAdjusted')}
          displayStartTimeClock={item.get('displayStartTimeClock')}
          startOnInReverse={item.get('startOnInReverse')}
        />
      </div>
    ) : null;

    const presetClock = displayPresetDuration ? (
      <div
        style={style}
        className={classNames({ 'cs-cell-selected': presetSelected })}
      >
        <PresetDuration
          {...this.props}
          isSelected={presetSelected}
          presetDurationDisplayType={presetDurationDisplayType}
          displayPresetDuration={displayPresetDuration}
          value={item.get('presetDurationInSecondsAdjusted')}
        />
      </div>
    ) : null;

    const durationClock = displayDuration ? (
      <div
        style={style}
        className={classNames({ 'cs-cell-selected': durationSelected })}
      >
        <Duration
          {...this.props}
          displayDuration={displayDuration}
          durationDisplayType={durationDisplayType}
          showRunTimeSuppressionToggle
          isSelected={durationSelected}
          value={item.get('durationInSeconds')}
        />
      </div>
    ) : null;

    if (width === ColumnWidthStrings.UltraNarrow) {
      return (
        <div className="cs-item-cell-clocks">
          <Row>
            <Col sm={24}>
              <div className="flex">{startClock}</div>
            </Col>
            <Col sm={24}>{presetClock}</Col>
            <Col sm={24}>{durationClock}</Col>
          </Row>
        </div>
      );
    }

    if (width === ColumnWidthStrings.Narrow) {
      return (
        <div className="cs-item-cell-clocks">
          <Row>
            <Col sm={24}>
              <div className="flex">
                {startClock}
                {presetClock || null}
              </div>
            </Col>
            <Col sm={24}>
              <div className="flex">{durationClock || null}</div>
            </Col>
          </Row>
        </div>
      );
    }

    return (
      <div className="cs-item-cell-clocks">
        <Row>
          <Col sm={24}>
            <div className="flex">
              {startClock}
              {presetClock}
              {durationClock}
            </div>
          </Col>
        </Row>
      </div>
    );
  },

  _getDescriptionNode() {
    const { checkSelectionStatus, editing, displayDescriptions } = this.props;

    if (!displayDescriptions) return null;

    return (
      <Description
        {...this.props}
        isCopied={this.props.isDescriptionCopied}
        isSelected={checkSelectionStatus(EditableCellTypes.ItemDescription)}
        isEditing={editing === EditableCellTypes.ItemDescription}
        placeholder={PlaceholderItemDescription}
        partialCell
      />
    );
  },
});
